import React, { useState, useCallback } from 'react'
import { I18n } from 'react-redux-i18n'
import { Button, Col, CustomInput, Container, Row, Modal, ModalFooter, ModalBody, ModalHeader } from 'reactstrap'
import { useDispatch } from 'react-redux'

import { deleteCompany } from 'redux/actions/companies'
import { logout } from 'redux/actions/user'
import Nixi1Spinner from 'components/Nixi1Spinner'

const DeleteStepView = ({ step, downloadData, onChange }) => {
  switch (step) {
    case 2:
      return (
        <Row>
          <Col xs='12'>
            <p dangerouslySetInnerHTML={{ __html: I18n.t('company_delete_account_wait') }}></p>
            <Nixi1Spinner width='25px' height='25px' />
          </Col>
        </Row>
      )
    case 3:
      return (
        <Row>
          <Col xs='12'>
            <p>
              <strong>{I18n.t('company_delete_account_end')}</strong>
            </p>
          </Col>
        </Row>
      )
    case 4:
      return (
        <Row>
          <Col xs='12'>
            <p className='text-uppercase'>
              <strong>{I18n.t('error_company_delete_account')}</strong>
            </p>
          </Col>
        </Row>
      )
    default:
      return (
        <Row>
          <Col xs='12'>
            <p dangerouslySetInnerHTML={{ __html: I18n.t('company_delete_account') }}></p>
          </Col>

          <Col xs='12'>
            <CustomInput
              type='checkbox'
              name='downloadData'
              id='download_data'
              checked={downloadData || false}
              onChange={onChange}
              label={
                <label htmlFor='download_data' className='input_checkbox'>
                  {I18n.t('company_delete_check_download_data')}
                </label>
              }
              inline
            />
          </Col>
        </Row>
      )
  }
}

/**
 * @param {object} props
 * @param {object} props.company
 * @param {boolean} [props.isDisabled=false]
 */
const ButtonDeleteCompany = (props) => {
  const { isDisabled = false } = props

  const dispatch = useDispatch()

  const [open, setOpen] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [step, setStep] = useState(1)

  const [downloadData, setDownloadData] = useState(false)

  const onOpen = useCallback(() => {
    if (!disabled) {
      setOpen(!open)

      setTimeout(() => {
        setStep(1)
        setDownloadData(false)
      }, 200)
    }
  }, [open, disabled])

  const onChange = useCallback(({ target: { checked } }) => {
    setDownloadData(checked)
  }, [])

  const onDelete = async () => {
    setDisabled(true)
    setStep(2)

    try {
      await dispatch(deleteCompany(downloadData))
      setStep(3)

      setTimeout(() => {
        setDisabled(false)
        dispatch(logout())
      }, 3000)
    } catch (error) {
      setStep(4)
      setDisabled(false)
    }
  }

  return (
    <>
      <Button onClick={onOpen} type='button' disabled={isDisabled} color='danger'>
        {I18n.t('button_company_delete_account')}
      </Button>

      <Modal isOpen={open} toggle={onOpen}>
        <ModalHeader toggle={onOpen}>{I18n.t('company_delete_account_header')}</ModalHeader>

        <ModalBody>
          <Container>
            <DeleteStepView step={step} downloadData={downloadData} onChange={onChange} />
          </Container>
        </ModalBody>

        <ModalFooter>
          <Button color='primary' onClick={onOpen} disabled={disabled}>
            {I18n.t('dashboard_cancel')}
          </Button>

          <Button color='primary' onClick={onDelete} disabled={disabled}>
            {I18n.t('dashboard_confirm')}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default ButtonDeleteCompany
